<template>
    <div>
        <Loader :loader-primario="loader"></Loader>

        <alerta v-on:fecharModal="fecharModal" :exibir="modal.exibir" :titulo="modal.titulo"
            :mensagem="modal.mensagem"></alerta>

        <v-container>
            <div class="card">
                <div class="inicio-titulo">
                    <v-img class="icone-titulo"
                        src="../../assets/images/icone/espaco-colaborador/icone_folha_de_ponto.svg"></v-img>
                    <h1 class="titulo">Folha de Ponto</h1>
                </div>


                <div class="info-box">
                    <v-icon class="info-box-icone">fas fa-circle-info</v-icon>
                    <span class="info-box-barra"></span>
                    <p class="info-box-texto">A folha de ponto do mês atual está disponível para download no botão localizado ao final das orientações. E tem novidade: agora você também conta com um novo botão para acessar o sistema e enviar sua folha de ponto de forma rápida e prática.</p>
                </div>


                <div class="secao-titulo">
                    <span class="secao-barra"></span>
                    <h2>ORIENTAÇÕES PARA PREENCHIMENTO DA FOLHA DE PONTO</h2>
                </div>


                <div class="faq-list">


                    <div class="faq">
                        <p class="pergunta">Quando devo baixar a folha de ponto?</p>
                        <p class="resposta">A folha de ponto é disponibilizada no primeiro dia do mês e a folha dos
                            meses anteriores não fica disponível. Por isso, lembre-se de baixar e imprimir sua folha
                            sempre no primeiro dia útil!</p>
                    </div>


                    <div class="faq">
                        <p class="pergunta">Como devo preencher a folha de ponto?</p>
                        <p class="resposta">Vamos detalhar a folha passo a passo para você. Vamos lá?</p>

                        <div class="figura figura-borda">
                            <img :src="img('exemplo-folha-preenchida.png')"
                                alt="Exemplo da folha de ponto preenchida" @error="onImgErro" />
                            <span class="figura-placeholder">Exemplo da folha de ponto preenchida</span>
                        </div>

                        <div class="subs">
                            <p class="resposta"><strong>2.1. Dados do colaborador:</strong> A parte superior contém
                                seus dados. Confira antes de imprimir.</p>

                            <p class="resposta"><strong>2.2. Horários de entrada e saída:</strong> Preencha a folha com
                                seu horário de entrada e saída todos os dias de trabalho. Esses horários registrados
                                devem refletir exatamente a jornada realizada por você. Não pode ser preenchida a folha
                                em um único dia e deve ser observado o intervalo mínimo de 1 (uma) hora para descanso e
                                alimentação.</p>

                            <p class="resposta"><strong>2.3. Código:</strong> Sempre que houver um evento na sua jornada
                                de trabalho e que precise ser identificado na folha de ponto, use o código
                                correspondente:</p>

                            <div class="figura">
                                <img :src="img('codigos-folha.png')" alt="Códigos da folha de ponto"
                                    @error="onImgErro" />
                                <span class="figura-placeholder">Códigos da folha de ponto</span>
                            </div>
                            <p class="resposta">(Vamos detalhar cada um mais para frente).</p>

                            <p class="resposta"><strong>2.4. Horas extraordinárias:</strong> Registre as horas
                                trabalhadas que excederem sua jornada de trabalho.<br />
                                Também preencha com "sim" ou "não" se as horas excepcionais foram previamente aprovadas
                                pelo gestor responsável. Relembramos que todas as horas extraordinárias trabalhadas serão
                                consideradas como banco de horas.</p>

                            <p class="resposta"><strong>Atenção:</strong> Sabemos que imprevistos acontecem, mas
                                reforçamos que, dentro do possível, qualquer realização de horas extras ou compensação de
                                jornada deve ser previamente alinhada e autorizada pela sua gestão.</p>

                            <p class="resposta"><strong>2.5. Assinatura:</strong> Assine todos os campos à mão.</p>
                        </div>
                    </div>


                    <div class="faq">
                        <p class="pergunta">Posso fazer uma jornada inteira sem pausas?</p>
                        <p class="resposta"><span class="destaque-nao">Não!</span></p>
                        <p class="resposta">Respeite seus intervalos. Pausas são necessárias para seu bem-estar,
                            organização e qualidade de vida e do trabalho.</p>
                        <p class="resposta"><strong>Jornada de 6 horas:</strong> OBRIGATÓRIO um intervalo de <strong>15
                                minutos</strong>.</p>
                        <p class="resposta"><strong>Jornada superior a 6 horas:</strong> OBRIGATÓRIO intervalo de no
                            <strong>mínimo uma hora</strong>, respeitada sua jornada de trabalho.</p>
                    </div>


                    <div class="faq">
                        <p class="pergunta">Quais cuidados devo ter com a folha de ponto?</p>
                        <p class="resposta">Preencha com caneta azul ou preta. Tenha atenção especial para que a folha
                            não contenha rasuras, emendas, rasgos ou sujeiras que dificultem a leitura dos registros, bem
                            como que todo conteúdo seja escrito de forma clara e legível, evitando qualquer dúvida nas
                            informações.</p>
                    </div>


                    <div class="faq">
                        <p class="pergunta">O que devo fazer em caso de ausência?</p>
                        <p class="resposta">Em caso de ausência, use os seguintes códigos para facilitar a identificação
                            do motivo.</p>

                        <div class="codigos">
                            <div class="codigo-card" v-for="codigo in codigos" :key="codigo.num">
                                <span class="codigo-num">{{ codigo.num }}&nbsp;&nbsp;{{ codigo.titulo }}</span>
                                <span class="codigo-desc">{{ codigo.descricao }}</span>
                            </div>
                        </div>
                    </div>


                    <div class="faq">
                        <p class="pergunta">Posso preencher a folha de ponto no final do mês?</p>
                        <p class="resposta">Não. O preenchimento deve ser realizado diariamente, garantindo que os
                            horários registrados reflitam efetivamente a jornada cumprida.</p>
                    </div>


                    <div class="faq">
                        <p class="pergunta">Quando utilizar o campo "Observações"?</p>
                        <p class="resposta">Utilize o campo <strong>Observações</strong> sempre que precisar complementar
                            ou esclarecer alguma informação relacionada ao preenchimento da folha de ponto, como a
                            correção de um código informado incorretamente.</p>

                        <div class="figura figura-borda figura-center">
                            <img :src="img('campo-observacoes.png')" alt="Campo Observações" @error="onImgErro" />
                            <span class="figura-placeholder">Campo Observações</span>
                        </div>
                    </div>


                    <div class="faq">
                        <p class="pergunta">O que devo fazer quando o mês terminar?</p>
                        <p class="resposta">Ao final do mês, digitalize a folha de ponto ou tire uma foto nítida do
                            documento.</p>
                    </div>


                    <div class="faq">
                        <p class="pergunta">Como faço a assinatura da folha de ponto?</p>
                        <p class="resposta">Após digitalizar o documento, realize a assinatura digital utilizando sua
                            conta do <span class="link-underline">Gov.br</span> no espaço indicado.</p>

                        <div class="figura figura-borda figura-center">
                            <img :src="img('assinatura-govbr.png')" alt="Assinatura digital gov.br"
                                @error="onImgErro" />
                            <span class="figura-placeholder">Assinatura digital gov.br</span>
                        </div>
                    </div>


                    <div class="faq">
                        <p class="pergunta">Onde devo enviar a folha de ponto assinada?</p>
                        <p class="resposta">Depois de assinar digitalmente, acesse o novo sistema de envio de folha de ponto e anexe o arquivo no local indicado. O botão de acesso ao novo sistema está logo abaixo desta orientação.</p>
                    </div>
                </div>


                <div class="rodape-botoes">
                    <v-btn ref="btnEnviar" class="botao-acao" depressed @click="abrirModalRedirecionar()">
                        <v-icon left>fas fa-upload</v-icon>
                        Enviar Minha Folha de Ponto
                    </v-btn>
                    <v-btn class="botao-acao" depressed @click="baixarFolhaDePonto()">
                        <v-icon left>fas fa-download</v-icon>
                        Baixar Minha Folha de Ponto
                    </v-btn>
                </div>
            </div>
        </v-container>

        <ModalRedirecionarFolha v-model="modalRedirecionar" @continuar="redirecionarFolhaPonto"
            @fechar="restaurarFocoEnviar"></ModalRedirecionarFolha>
    </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import alerta from "@/components/Alerta.vue";
import ModalRedirecionarFolha from "@/components/EspacoDoColaborador/FolhaDePonto/ModalRedirecionarFolha.vue";
import api from "@/services/Api.js";
import modalMixin from "@/mixins/modalMixin";

// Sistema externo de envio da folha de ponto assinada.
const URL_ENVIO_FOLHA = "https://folhadeponto.hepta.com.br/";

export default {
    components: { Loader, alerta, ModalRedirecionarFolha },
    name: "folhadeponto",
    mixins: [modalMixin],
    data() {
        return {
            loader: false,
            modalRedirecionar: false,
            codigos: [
                {
                    num: "01",
                    titulo: "Afastamento",
                    descricao:
                        "Por motivos de saúde, acidente ou licenças. (Exemplos: licença-maternidade, licença-paternidade, afastamento pelo INSS, licença médica superior a 15 dias).",
                },
                {
                  num: "02",
                  titulo: "Falta não justificada",
                  descricao:
                      "As faltas não justificadas pela CLT são aquelas sem comprovação legal, não são abonadas pelo empregador e geram desconto no salário, perda do descanso semanal remunerado (DSR) e redução dos dias de férias e outras repercussões legais.",
                },
                {
                    num: "03",
                    titulo: "Falta justificada",
                    descricao:
                        "São ausências legais que não geram desconto no salário, previstas no artigo 473 da CLT. (Exemplos: apresentação de atestado médico homologado, em caso de casamento (licença-gala), ou comprovante de comparecimento à Justiça, quando aplicável, doação voluntária de sangue). Lembrando que sempre é necessário o respectivo documento. Lembre-se sempre de anexar os atestados médicos no Nossa Hepta.",
                },
                {
                    num: "04",
                    titulo: "Feriado",
                    descricao: "Descanso estabelecido por lei ou decreto.",
                },
                {
                    num: "05",
                    titulo: "Férias",
                    descricao:
                        "Período de descanso remunerado garantido por lei ao trabalhador após 12 meses de trabalho — as férias devem ser agendadas no sistema disponível pela HEPTA.",
                },
                {
                    num: "06",
                    titulo: "Compensação",
                    descricao:
                        "O código de compensação deve ser utilizado para registrar a utilização do banco de horas.",
                },
            ],
        };
    },
    methods: {
        img(nome) {
            return `${process.env.BASE_URL}folha-de-ponto/${nome}`;
        },
        onImgErro(e) {
            const img = e.target;
            img.style.display = "none";
            const placeholder = img.nextElementSibling;
            if (placeholder) placeholder.style.display = "flex";
        },
        abrirModalRedirecionar() {
            this.modalRedirecionar = true;
        },
        restaurarFocoEnviar() {
            // Devolve o foco ao botão que abriu a modal (acessibilidade).
            this.$nextTick(() => {
                const botao = this.$refs.btnEnviar;
                if (botao && botao.$el) botao.$el.focus();
            });
        },
        redirecionarFolhaPonto() {
            // Abre o sistema externo em uma nova aba. Sem token/sessão/CPF/
            // matrícula na URL; noopener/noreferrer impede que o destino
            // acesse a janela de origem (window.opener) ou receba o Referer.
            window.open(URL_ENVIO_FOLHA, "_blank", "noopener,noreferrer");
        },
        baixarFolhaDePonto() {
            const vm = this;
            vm.loader = true;
            api
                .get("folhaPontoColaborador/folha", {
                    responseType: "arraybuffer",
                    headers: {
                        Accept: "application/pdf",
                        Authorization: localStorage.token,
                    },
                })
                .then((response) => {
                    const blob = new Blob([response.data], { type: "application/pdf" });
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "folha-de-ponto.pdf");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch((e) => {
                    vm.mensagemErro(e.message);
                })
                .finally(() => {
                    vm.loader = false;
                });
        },
    },
};
</script>

<style scoped>
.info-box {
    display: flex;
    align-items: center;
    gap: 2rem;
    background-color: #edefee;
    border-radius: 10px;
    padding: 10px 10px 10px 32px;
    margin-bottom: 2rem;
}

.info-box-icone {
    color: #278b97 !important;
    font-size: 35px;
}

.info-box-barra {
    width: 2px;
    height: 64px;
    background-color: #278b97;
    border-radius: 5px;
    flex-shrink: 0;
}

.info-box-texto {
    color: #1f1f1f;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 0 !important;
}


.secao-titulo {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 1.5rem;
}

.secao-barra {
    width: 4px;
    height: 22px;
    background-color: #278b97;
    border-radius: 4px 0 0 4px;
    flex-shrink: 0;
}

.secao-titulo h2 {
    color: #278b97;
    font-family: Montserrat, sans-serif;
    font-weight: 700;
    font-size: 18px;
    text-transform: uppercase;
    margin: 0;
}


.faq-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.faq {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.pergunta {
    position: relative;
    color: #e7b814;
    font-family: Montserrat, sans-serif;
    font-weight: 700;
    font-size: 13px;
    padding-left: 14px;
    margin-bottom: 0 !important;
}

.pergunta::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 7px solid #e7b814;
}

.resposta {
    color: #5f5f5f;
    font-family: Montserrat, sans-serif;
    font-weight: 400;
    font-size: 12.5px;
    line-height: 20.63px;
    margin-bottom: 0 !important;
}

.resposta strong {
    color: #3f3f3f;
    font-weight: 700;
}

.destaque-nao {
    color: #3f3f3f;
    font-weight: 700;
    text-decoration: underline;
}

.link-underline {
    text-decoration: underline;
}

.subs {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
}

.figura {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    overflow: hidden;
}

.figura-borda {
    border: 1px solid #e6e6e6;
}

.figura-center {
    justify-content: center;
}

.figura img {
    max-width: 100%;
    height: auto;
    display: block;
}

.figura-placeholder {
    display: none;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 120px;
    background-color: #f5f5f5;
    color: #9e9e9e;
    font-size: 12.5px;
    font-style: italic;
    text-align: center;
    padding: 1rem;
}

.codigos {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;
}

.codigo-card {
    display: flex;
    align-items: center;
    gap: 16px;
    background-color: #ffffff;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 24px 16px;
}

.codigo-num {
    color: #32acb9;
    font-family: Montserrat, sans-serif;
    font-weight: 700;
    font-size: 12.5px;
    min-width: 119px;
    flex-shrink: 0;
}

.codigo-desc {
    color: #5f5f5f;
    font-family: Montserrat, sans-serif;
    font-weight: 400;
    font-size: 12.5px;
    line-height: 20px;
}

.rodape-botoes {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 24px;
    margin-top: 2rem;
}

.botao-acao {
    background-color: #32acb9 !important;
    color: #ffffff !important;
    border-radius: 10px !important;
    height: 48px !important;
    padding: 10px 24px !important;
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0;
    text-transform: none;
    box-shadow: none !important;
}

@media screen and (max-width: 768px) {
    .info-box {
        gap: 1rem;
        padding: 10px 12px;
    }

    .codigo-card {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }

    .rodape-botoes {
        justify-content: center;
    }
}
</style>
